import { Box, Flex, Text } from "rebass/styled-components";
import { isIOS } from "react-device-detect";
import { useState } from "react";
import styled from "styled-components";
import { IoMdClose } from "react-icons/io";
import { useRecoilValue } from "recoil";

import { ActiveOverlayPopUpState } from "MVVM/State/iframe";
import { IClip } from "MVVM/@types";
import { gameKeyToGameName } from "../../utils";
import { Button } from "MVVM/Components/Button";
import { useAnalyticsContext } from "MVVM/Hooks/useAnalyticsContext";
import "./index.css";

export const MobileAdBanner = ({ clip }: { clip: IClip }) => {
  const activeOverlayPopUp = useRecoilValue(ActiveOverlayPopUpState);
  const [hideBanner, setHideBanner] = useState(false);
  const [trackedDisplay, setTrackedDisplay] = useState(false);
  const { track } = useAnalyticsContext();

  if (activeOverlayPopUp || hideBanner) return null;

  if (!trackedDisplay) {
    track("Component Viewed", {
      locationIdentifier: "mobile_ad_banner",
      location: "embeddable_player_overlay",
    });
    setTrackedDisplay(true);
  }

  return (
    <Container className="mobile-ad-banner__container">
      <AppStoreImage
        className="mobile-ad-banner__appstore-image"
        src={
          isIOS
            ? process.env.REACT_APP_S3_CLIP_BUCKET +
              "/static/web/mobile/appstorechooser/ios.png"
            : process.env.REACT_APP_S3_CLIP_BUCKET +
              "/static/web/mobile/appstorechooser/android.png"
        }
      />

      <Box className="mobile-ad-banner__text-container">
        <StyledHeadline className="mobile-ad-banner__headline">
          {isIOS ? "Get The iOS App" : "Get The Android App"}
        </StyledHeadline>
        <StyledCopy className="mobile-ad-banner__copy">
          Create & watch your best {gameKeyToGameName(clip.game)} moments on the
          go!
        </StyledCopy>
      </Box>
      <StyledButton
        className="mobile-ad-banner__button"
        onClick={() => {
          const ajs_aid = window.rudderanalytics.getAnonymousId();
          track("Button - Click", {
            locationIdentifier: "install_button",
            location: "embeddable_player_overlay",
          });
          window.open(
            `https://allstar.gg/apponelink?ajs_aid=${ajs_aid}`,
            "_blank",
          );
        }}
      >
        <StyledButtonText
          className="mobile-ad-banner__button-text"
          variant="text.labelSmall"
        >
          Install
        </StyledButtonText>
      </StyledButton>
      <Flex
        className="mobile-ad-banner__close"
        onClick={() => setHideBanner(true)}
        style={{ pointerEvents: "auto", cursor: "pointer" }}
      >
        <StyledCloseIcon className="mobile-ad-banner__close-icon" />
      </Flex>
    </Container>
  );
};

const StyledButtonText = styled(Text)``;
StyledButtonText.displayName = "StyledButtonText";

const StyledButton = styled(Button)`
  align-items: center;
  border-radius: 99px;
  display: flex;
  font-size: 10px;
  gap: 5px;
  height: 25px;
  justify-content: center;
  padding: 8px;
  width: 60px;
`;
StyledButton.displayName = "StyledButton";

const AppStoreImage = styled.img`
  height: 24px;
  width: auto;
`;
AppStoreImage.displayName = "AppStoreImage";

const StyledCloseIcon = styled(IoMdClose)`
  color: ${({ theme }) => theme.colors.chalk};
  flex-shrink: 0;
  height: 8px;
  width: 8px;
`;
StyledCloseIcon.displayName = "StyledCloseIcon";

const StyledHeadline = styled(Text)`
  color: white;
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
`;
StyledHeadline.displayName = "StyledHeadline";

const StyledCopy = styled(Text)`
  color: rgba(255, 255, 255, 0.6);
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
`;
StyledCopy.displayName = "StyledCopy";

const Container = styled(Flex)`
  align-items: center;
  background-color: #000000bf;
  border-radius: 10px;
  gap: 8px;
  justify-content: space-between;
  padding-left: 8px;
  padding: 4px;
  pointer-events: auto;
  position: absolute;
  right: 5px;
  top: 20px;
`;
Container.displayName = "Container";
